package de.ohhhmhhh.backend.models.model.revocation

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RevocationFilterEntity(
    @SerialName("search")
    val search: String? = null,
    @SerialName("contractType")
    val contractType: RevocationContractTypeEntity? = null,
    @SerialName("state")
    val state: RevocationStateEntity? = null
)
